import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ew-request-provider',
  templateUrl: './request-provider.component.html',
  styleUrl: './request-provider.component.scss',
})
export class RequestProviderComponent implements OnInit {
  provider: any = null;

  constructor(
    private TRANSLATE: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private API: ApiService,
  ) {
    this.provider = data;
  }

  ngOnInit(): void {
    this.API.get(`v1/companies/${localStorage.getItem('company')}`).subscribe(
      (response: any) => {
        this.form
          .get('text')
          ?.setValue(
            this.TRANSLATE.instant('requestNewProvider:emailText').replace(
              'school_name_placeholder',
              this.provider.name,
            ),
          );
        this.form
          .get('subject')
          ?.setValue(
            this.TRANSLATE.instant('requestNewProvider:subject').replace(
              'company_name_placeholder',
              response.company.name,
            ),
          );
      },
    );
  }

  form: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/),
    ]),
    text: new FormControl('', [Validators.required]),
    subject: new FormControl('', [Validators.required]),
  });

  loading = false;

  get validations() {
    return [this.form.valid];
  }

  requestProvider() {
    this.loading = true;
    this.API.post('v1/verified-provider/request-join', {
      ...this.form.value,
      ...this.provider,
    }).subscribe(
      (response: any) => {
        if (response.record.ErrorCode == 0) this.loading = false;
      },
      (err) => {
        this.loading = false;
      },
    );
  }
}
